import { Component, OnInit } from '@angular/core';
import { zip } from 'rxjs';
import { SessionDataService } from '../../services/session-data.service';
import {ActivatedRoute, NavigationExtras, ParamMap, Router} from '@angular/router';
import { UserData, UserRoute } from './user.models';
import { TranslateService } from '@ngx-translate/core';
import { InovaCommonGraphqlApi } from 'inova-front-core/helpers/services/http';

@Component({
  selector: 'lib-role-check',
  templateUrl: './role-check.component.html',
  styleUrls: ['./role-check.component.css']
})
export class RoleCheckComponent implements OnInit {

  constructor(private inovaCommonGraphqlApi: InovaCommonGraphqlApi, private sessionDataService:SessionDataService,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private router: Router) {}

  ngOnInit(): void {
    zip(
      this.inovaCommonGraphqlApi.getUserRole(),
      this.inovaCommonGraphqlApi.getUserLanguage(),
      this.inovaCommonGraphqlApi.getClientLanguage(),
      this.inovaCommonGraphqlApi.getClientServices()
    ).subscribe(response => {
      const user:UserData=response[0];
      this.evaluatePermissions(user.usuariopermisos);
      this.sessionDataService.setUserLanguage(response[1]);
      this.sessionDataService.setUserCountry(response[2].pais?.toUpperCase() || 'CO');
      this.translateService.setDefaultLang(response[2].idioma.toLowerCase());
      this.sessionDataService.setUserServices(response[3][0]);
      this.evaluateRole(user);
    });
  }

  private evaluatePermissions(permissions: any) {
    if (permissions && permissions.permisos) {
      this.sessionDataService.setUserPermissions(permissions.permisos);
    } else {
      this.sessionDataService.setUserPermissions([]);
    }
  }

  private setUserName(user: UserData){
    if (user.persona) {
      this.sessionDataService.setItem('username', { value: user.persona.nombre + " " + (user.persona.apellido || '') });
    }
    else {
      if (user.productor?.persona) {
        this.sessionDataService.setItem('username', { value: user.productor?.persona?.nombre + " " + (user.productor?.persona?.apellido || '') });
      }
    }
  }

  private evaluateRole(user: UserData) {
    this.setUserName(user);
    const userRoute:UserRoute=this.route.snapshot.data.userRoute;
    const userCallback=this.route.snapshot.data.userCallback;
    let customRedirect: string[] = [];
    this.route.queryParamMap.subscribe((paramMap: ParamMap) => {
      const redirectParam = paramMap.get('redirect');
      customRedirect = redirectParam ? [atob(redirectParam)] : customRedirect;
    });
    let route: any[] | null | undefined=null;
    let role='';
    if (user.administrador) {
      route=userRoute.admin;
      role='administrador';
    }
    if (user.cliente) {
      route=userRoute.cliente;
      role='cliente';
    }
    if (user.subcliente) {
      route=userRoute.subcliente;
      role='subcliente';
    }
    if (user.profesional) {
      route=userRoute.profesional;
      role='profesional';
    }
    if (user.productor) {
      route=userRoute.productor;
      role='productor';
    }
    if (user.analista) {
      route=userRoute.analista;
      role='analista';
    }
    if(route){
      this.sessionDataService.setUserRole(role);
      route = customRedirect.length > 0 ? customRedirect : route;
      const navigationExtras: NavigationExtras = {
        skipLocationChange: false 
      };
      setTimeout(()=>{
        if(Array.isArray(route)){
          this.router.navigate(route, navigationExtras);
        }
        else{
          this.router.navigate([route], navigationExtras);
        }
      },1000);
      
      if(userCallback){
        userCallback(user)
      }
    }
    else{
      this.sessionDataService.localLogout(true);
    }
  }

}
